import React from "react";
import { motion } from "framer-motion";
import { TrendingUp, Cpu, Megaphone, Globe2 } from "lucide-react";

const pillars = [
  { icon: TrendingUp, title: "Growth", desc: "Performance-driven strategies that accelerate business growth across every channel." },
  { icon: Cpu, title: "AI Solutions", desc: "Custom software, AI automation, CRM, ERP & SaaS platforms built for your business." },
  { icon: Megaphone, title: "Marketing", desc: "Digital campaigns, paid promotions, branding & media buying that convert." },
  { icon: Globe2, title: "Global Reach", desc: "Helping ambitious businesses expand their presence across global markets." },
];

export default function About() {
  return (
    <section id="about" className="relative py-32 overflow-hidden">
      <div className="absolute -top-40 right-0 aurora w-[520px] h-[520px] bg-[#047857]" style={{opacity:0.15}} />
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-14 items-start">
          <div className="lg:col-span-5">
            <span className="eyebrow">About SYR Mediaworks</span>
            <motion.h2
              initial={{opacity:0,y:20}} whileInView={{opacity:1,y:0}} viewport={{once:true}} transition={{duration:0.7, ease:[0.16,1,0.3,1]}}
              className="mt-6 text-4xl md:text-5xl lg:text-6xl font-semibold leading-[1.05]"
            >
              Building <span className="text-gold-gradient">tomorrow's</span> digital <span className="text-emerald-gradient">success stories.</span>
            </motion.h2>
            <div className="mt-8 hairline max-w-md" />
            <p className="mt-8 text-white/70 leading-relaxed text-lg">
              SYR Mediaworks is a next-generation digital marketing and technology company
              helping businesses scale through AI-powered innovation, creative branding,
              performance marketing, custom software development and intelligent automation.
            </p>
            <p className="mt-5 text-white/60 leading-relaxed">
              From websites and mobile applications to paid advertising, social media management,
              outdoor branding, affiliate marketing and enterprise software — we empower startups,
              SMEs and global brands to grow faster, smarter and stronger.
            </p>

            <div className="mt-10 grid grid-cols-3 gap-4 max-w-md">
              {[["7+","Years"],["9","Industries"],["24×7","Support"]].map(([v,l])=>(
                <div key={l} className="glass rounded-2xl p-4">
                  <div className="text-2xl font-semibold text-gold-gradient">{v}</div>
                  <div className="text-xs uppercase tracking-widest text-white/50 mt-1">{l}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {pillars.map((p, i) => (
              <motion.div
                key={p.title}
                initial={{opacity:0,y:24}} whileInView={{opacity:1,y:0}} viewport={{once:true}} transition={{duration:0.6, delay: i*0.08, ease:[0.16,1,0.3,1]}}
                className="card-lift glass rounded-3xl p-7 relative overflow-hidden"
              >
                <div className="absolute -top-14 -right-14 w-40 h-40 rounded-full bg-[#C9A227]/10 blur-3xl" />
                <div className="w-12 h-12 rounded-xl grid place-items-center border border-[#C9A227]/40 bg-[#C9A227]/5">
                  <p.icon size={20} className="text-[#F4D983]" />
                </div>
                <h3 className="mt-5 text-2xl font-semibold">{p.title}</h3>
                <p className="mt-3 text-white/60 leading-relaxed text-[15px]">{p.desc}</p>
                <div className="mt-6 shimmer-line h-px" />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
